/**
 * Возвращает начальный индекс вхождения строки для поиска в исходной строке
 *
 * @param {string} str Исходная строка
 * @param {string} searchStr Строка для поиска
 * @returns {string} Начальный индекс вхождения
 */
function indexOf(str: string, searchStr: string, position?: number | undefined) {
  return normalize(str).indexOf(normalize(searchStr), position);
}

/**
 * Нормализация строки для поиска вхождений
 *
 * @param {string} str Строка для нормализации
 * @returns {string} Нормализованная строка
 */
function normalize(str: string): string {
  return (typeof str.normalize === 'function' ? str.normalize() : str)
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/й/g, 'и');
}

export const textSearch = {
  indexOf,
  normalize,
};
